import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Skeleton,
  Typography,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const SkeletonAccordion = ({ length = 5 }) => {
  return (
    <>
      {Array.from({ length }).map((_, index) => (
        <Accordion
          key={index}
          sx={{
            margin: "0px !important",
            boxShadow: "none !important",
            border: "1px solid rgba(234, 234, 234, 1)",
            borderBottom: "none",
            "&:first-child": {
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            },
            "&:last-child": {
              borderBottom: "1px solid rgba(234, 234, 234, 1)",
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
              marginBottom: "16px",
            },
            "&::before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              minHeight: "68px !important",
              borderBottom: "1px solid transparent",
              "&.Mui-expanded": {
                boxShadow: "0px 4px 8px -2px rgba(0, 0, 0, 0.16)",
                borderBottom: "1px solid rgba(234, 234, 234, 1)",
              },
              "& .MuiAccordionSummary-content": {
                alignItems: "center",
                margin: "0px !important",
              },
            }}
          >
            <KeyboardArrowRightIcon
              sx={{
                mr: "4px",
                color: "rgba(62, 63, 76, 1)",
                fontSize: "20px",
              }}
            />
            <Box display="flex" alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Box ml="16px">
                <Skeleton variant="text" width={100} />
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "8px 16px !important",
              backgroundColor: "rgba(249, 249, 252, 1)",
            }}
          >
            {Array.from({ length: 3 }).map((_, detailIndex) => (
              <Box
                key={detailIndex}
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                gap="20px"
                minHeight="54px"
              >
                <Typography
                  color="rgba(62, 63, 76, 0.75)"
                  sx={{
                    minWidth: "100px",
                    fontWeight: 400,
                    fontSize: "14px",
                  }}
                >
                  <Skeleton variant="text" width={80} />
                </Typography>
                <Typography
                  color="rgba(62, 63, 76, 1)"
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                  }}
                >
                  <Skeleton variant="text" width={120} />
                </Typography>
              </Box>
            ))}

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              gap="20px"
              minHeight="54px"
            >
              <Typography
                color="rgba(62, 63, 76, 0.75)"
                sx={{
                  minWidth: "100px",
                  fontWeight: 400,
                  fontSize: "14px",
                }}
              >
                <Skeleton variant="text" width={60} />
              </Typography>
              <Skeleton variant="rectangular" width={80} height={30} />
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default SkeletonAccordion;
